import { render, staticRenderFns } from "./SolePropM.vue?vue&type=template&id=dda1c318&scoped=true"
import script from "./SolePropM.vue?vue&type=script&lang=js"
export * from "./SolePropM.vue?vue&type=script&lang=js"
import style0 from "./SolePropM.vue?vue&type=style&index=0&id=dda1c318&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dda1c318",
  null
  
)

export default component.exports